import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

const Contact = () => {
  const { t } = useTranslation()
  const [form, setForm] = useState({
    name: '',
    email: '',
    phone: '',
    message: '',
  })

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value })
  }

  const handleSubmit = (e) => {
    e.preventDefault()

    const { name, email, phone, message } = form

    const text = `
🔔 ${t('contact.notify')}
👤 ${t('contact.name')}: ${name}
📧 ${t('contact.email')}: ${email}
📱 ${t('contact.phone')}: ${phone}
💬 ${t('contact.message')}: ${message}
    `

    fetch('https://api.telegram.org/bot7952650810:AAFmTvNCaAfD4kqubs8ePGGhQ_r-jZRFKKk/sendMessage', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        chat_id: '7850830300',
        text,
      }),
    })
      .then(() => {
        alert(t('contact.success'))
        setForm({ name: '', email: '', phone: '', message: '' })
      })
      .catch((err) => {
        console.error('Ошибка:', err)
        alert(t('contact.error'))
      })
  }

  return (
    <section className="contact" id="contact">
      <div className="container">
        <h2>{t('contact.title')}</h2>
        <form onSubmit={handleSubmit}>
          <input
            type="text"
            name="name"
            placeholder={t('contact.name')}
            onChange={handleChange}
            value={form.name}
            required
          />
          <input
            type="email"
            name="email"
            placeholder={t('contact.email')}
            onChange={handleChange}
            value={form.email}
            required
          />
          <input
            type="tel"
            name="phone"
            placeholder={t('contact.phone')}
            onChange={handleChange}
            value={form.phone}
          />
          <textarea
            name="message"
            placeholder={t('contact.message')}
            onChange={handleChange}
            value={form.message}
            required
          />
          <button type="submit" className="btn-primary">
            {t('contact.send')}
          </button>
        </form>
      </div>
    </section>
  )
}

export default Contact
